import type { IntlShape } from 'react-intl';

import { defined as sizesMessages } from '@/views/StrapView/components/Sizes/components/SizesModal/messages';
export const translateStrapSize = (
  label: string,
  formatMessage: IntlShape['formatMessage'],
) => {
  switch (label) {
    case 'Small':
      return formatMessage(sizesMessages.small);
    case 'Standard':
      return formatMessage(sizesMessages.standard);
    case 'Large':
      return formatMessage(sizesMessages.large);
    default:
      return label;
  }
};
